import { useState, useEffect, useMemo } from 'react';
import useChannelFetching from '../../Channels/hooks/useChannelFetching';

const useChannelSelection = (handleError) => {
    // Channel selection state
    const [selectedChannel, setSelectedChannel] = useState(null);

    // Fetch channels
    const {
        channels,
        loading,
        handleSearch
    } = useChannelFetching(handleError, { initialPageSize: 100 });

    // Auto-select first channel
    useEffect(() => {
        if (!selectedChannel && channels.length > 0) {
            setSelectedChannel(channels[0].id);
        }
    }, [channels, selectedChannel]);

    // Derive agent ID from selected channel for socket subscription
    const selectedChannelAgentId = useMemo(() => {
        return channels.find(c => c.id === selectedChannel)?.agent_id;
    }, [channels, selectedChannel]);

    return {
        channels,
        loading,
        selectedChannel,
        setSelectedChannel,
        selectedChannelAgentId,
        handleSearch
    };
};

export default useChannelSelection;
